import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-rename-dialog',
	template: `
		<div *ngIf="visible" class="rename-overlay" (click)="onCancel()" data-testid="rename-dialog-container">
			<div class="rename-dialog" (click)="$event.stopPropagation()">
				<h3>{{ title }}</h3>
				<input type="text" [(ngModel)]="value" (keydown.enter)="onSubmit()" (keydown.escape)="onCancel()" class="rename-input" autofocus data-testid="rename-dialog-input-name" />
				<div class="rename-actions">
					<app-button label="Cancel" category="primary" variant="outlined" [onClick]="onCancel" data-testid="rename-dialog-btn-cancel"></app-button>
					<app-button label="Save" category="primary" variant="contained" [onClick]="onSubmit" data-testid="rename-dialog-btn-save"></app-button>
				</div>
			</div>
		</div>
	`,
	styleUrls: ['./rename-dialog.component.scss'],
})
export class RenameDialogComponent {
	@Input() visible = false;
	@Input() title = 'Rename';
	@Input() value = '';
	@Output() valueChange = new EventEmitter<string>();
	@Output() submitted = new EventEmitter<string>();
	@Output() cancelled = new EventEmitter<void>();

	/** Submit the current value if non-empty. Arrow function preserves `this` for [onClick] binding. */
	readonly onSubmit = () => {
		const trimmed = this.value.trim();
		if (trimmed) {
			this.submitted.emit(trimmed);
		} else {
			this.onCancel();
		}
	};

	/** Cancel and close the dialog. Arrow function preserves `this` for [onClick] binding. */
	readonly onCancel = () => {
		this.cancelled.emit();
	};
}
